import React from 'react';
import { StyledColumnHeader } from '../SyncGitTeamsForm.style';
import { StyledTeamsPicker } from './TeamsPicker.style';
import TeamRow from './TeamRow';

const TeamsPicker = ({
  teams = [],
  selectedTeam,
  onClickTeam,
  isTeamChecked,
  isTeamChildChecked,
  toggleTeamCheckbox,
  orgName
}) => {
  return (
    <StyledTeamsPicker>
      <StyledColumnHeader>
        Teams from <b>{orgName}</b>
      </StyledColumnHeader>
      <main className='team-list'>
        {teams.map(team => (
          <TeamRow
            key={team.id}
            team={team}
            selectedTeam={selectedTeam}
            onClickTeam={onClickTeam}
            toggleTeamCheckbox={toggleTeamCheckbox}
            isTeamChecked={isTeamChecked}
            isTeamChildChecked={isTeamChildChecked}
          />
        ))}
      </main>
    </StyledTeamsPicker>
  );
};

export default TeamsPicker;
